// src/api/houtai/notifications.js
import request from '@/utils/request'

// 获取通知列表 - 对应后端 /getNotificationList
export const getNotificationList = (page, pageSize, type, keyword) => {
  return request.get('/houtai/getNotificationList', {
    params: {
      page: page,
      pageSize: pageSize,
      type: type,
      keyword: keyword
    }
  })
}

// 发布通知 - 对应后端 /addNotification
export const publishNotification = (data) => {
  return request.post('/houtai/addNotification', data)
}

// 删除通知 - 对应后端 /deleteNotification
export const deleteNotification = (id) => {
  return request.post('/houtai/deleteNotification', { id: id })
}

// 批量删除 - 对应后端 /batchDeleteNotifications
export const batchDeleteNotifications = (ids) => {
  return request.post('/houtai/batchDeleteNotifications', { ids: ids })
}

// 获取通知统计 - 对应后端 /getNotificationStats
export const getNotificationStats = (id) => {
  return request.get('/houtai/getNotificationStats', {
    params: { id: id }
  })
}